<template lang="html">
  <app-loading :loading="loading">

    <div class="body">
      <MainInfo/>
      <VarietyImage/>
      <Variety/>
      <GrowingMethods/>
      <YieldGoal v-if="!hydro"/>
    </div>

    <Stages/>
  </app-loading>
</template>

<script>
import MainInfo from '@/components/crops/single/MainInfo'
import Variety from '@/components/crops/single/Variety'
import VarietyImage from '@/components/crops/single/VarietyImage'
import YieldGoal from '@/components/crops/single/YieldGoal'
import GrowingMethods from '@/components/crops/single/GrowingMethods'
import Stages from '@/components/crops/single/Stages'

export default {
  data() {
    return {
      test: null,
      loading: false,
      hydro: false
    }
  },
  components: {
    MainInfo,
    Variety,
    YieldGoal,
    GrowingMethods,
    VarietyImage,
    Stages,
  },
  methods: {
    //=================================================================================
    sync(id) {
      this.loading = true;
      this.$store.dispatch('crop/updateBaseCrop', id).then(res => {
        console.log(res.data.data)
        this.hydro = res.data.data.type == 'soil-grown' ? false : true;
        this.loading = false;
      })
      .catch(err=>{
        this.$notify({
                  group: "notices",
                  title: this.$ml.get(
                    `Please buy a plan before selecting crops.`
                  ),
                  type: "error",
                });
                this.loading = false;
      });
    }
  },
  //=================================================================================
  created() {
    this.sync(this.$route.params.crop);
  },
  beforeRouteUpdate(to, from, next) {
    this.sync(to.params.crop);
    next();
  }
}
</script>

<style lang="scss" scoped>

.crop-single {
  min-height: 100vh;
  padding: 0 8px;

  .body {

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: stretch;
    justify-content: flex-start;

    .variety {
      min-width: calc(33.3% - 8px);
      max-width: calc(33.3% - 8px);
      margin-bottom: 8px;
      margin-right: 8px;
      height: 200px;
    }

    .variety-image {
      min-width: calc(33.3% - 8px);
      max-width: calc(33.3% - 8px);
      margin-bottom: 8px;
      margin-right: 8px;
      height: 200px;
    }

    .growing-methods {
      min-width: calc(33.3%);
      max-width: calc(33.3%);
      margin-bottom: 8px;
      height: 200px;
    }

    .yield-goal {
      width: 100%;
      height: 300px;
      margin-bottom: 8px;
    }

    @media (max-width: 1230px) {
      .variety {
        min-width: calc(50%);
        max-width: calc(50%);
        margin-right: 0;
      }

      .variety-image {
        min-width: calc(50% - 8px);
        max-width: calc(50% - 8px);
        margin-bottom: 8px;
        margin-right: 8px;
      }

      .growing-methods {
        min-width: calc(50% - 8px);
        max-width: calc(50% - 8px);
        margin-bottom: 0;
        margin-right: 8px;
        height: 300px;
      }

      .yield-goal {
        min-width: calc(50%);
        max-width: calc(50%);
        height: 300px;
      }
    }

    // .sub-body {
    //   flex-grow: 1;
    //   display: flex;
    //   flex-direction: row;
    //   position: relative;
    //   align-items: stretch;
    //   margin-bottom: 8px;

      // .blocker {
      //   position: absolute;
      //   width: 100%;
      //   height: 100%;
      //   border-radius: 10px;
      //   background: rgba(0, 0, 0, 0.5);
      //   z-index: 101;

      //   display: flex;
      //   align-items: center;
      //   justify-content: center;
      // }
    // }

  }
  @media(max-width:768px) {
    padding: 0;
    .body {
      flex-wrap: wrap;
      > div {
        max-width: 100%!important;
        flex-basis: 100%;
        margin-right: 0!important;
        margin-left: 0!important;
      }
    }
  }
}
body[dir="rtl"] {
  main {
    .body {
      .variety-image, .variety {
        margin-right: 0;
        margin-left: 8px;
      }
    }
  }
}

</style>
